import { useState } from 'react';
import {
  ChromePicker,
  Color,
  ColorChangeHandler,
  ColorResult,
  RGBColor,
} from 'react-color';

import { theme } from '../../theme';

interface ColorPickerProps {
  color?: Color | undefined;
  onChange?: ColorChangeHandler | undefined;
}
const ColorPicker = ({ onChange, color }: ColorPickerProps) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };
  return (
    <>
      <div
        onClick={handleClick}
        style={{
          background: `rgba(${Object.values(color || {})})`,
          padding: '7px',
          borderRadius: '2px',
          marginLeft: '10px',
          boxShadow: theme.custom?.swatchShadow,
          display: 'inline-block',
          cursor: 'pointer',
        }}
      ></div>
      {displayColorPicker ? (
        <div
          style={{
            position: 'absolute',
            zIndex: '2',
          }}
        >
          <div
            style={{
              position: 'fixed',
              top: '0px',
              right: '0px',
              bottom: '0px',
              left: '0px',
            }}
            onClick={handleClose}
          />
          <ChromePicker
            disableAlpha
            color={color}
            onChangeComplete={onChange}
          />
        </div>
      ) : null}
    </>
  );
};

export { ColorPicker };
export type { ColorResult, RGBColor };
export default ColorPicker;
